import { useMemo } from 'react';

import { useUserInfo } from '@/common/hooks';

import { BaseIdentityAttrs } from '../types';

export const useBaseIdentityAttrs = (): BaseIdentityAttrs | null => {
	const { data: user } = useUserInfo();

	return useMemo(() => {
		if (!user) return null;
		return {
			role: user.userType,
			userDomain: user.userDomain.domain,
		};
	}, [user]);
};
